import { render, staticRenderFns } from "./OrdersED.vue?vue&type=template&id=52eca3d4"
import script from "./OrdersED.vue?vue&type=script&lang=js"
export * from "./OrdersED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports